export const setLanguageCode = (code) => {
  if (typeof window !== 'undefined') {
    const oldCode = window?.localStorage?.getItem('i18n-language-code', code)
    if (oldCode !== code) {
      window?.localStorage?.setItem('i18n-language-code', code)
      window.location.reload()
    }
  }
}

export default setLanguageCode
